import {axiosClient} from '../axios';
import {VisitorActivityAction, VisitorActivityCategory} from '../constants';

export interface VisitorActivityPayloadType {
  url: string;
  source?: string;
  events: Array<{
    category: VisitorActivityCategory;
    action: VisitorActivityAction;
    product_id?: string;
    external_shop_id?: string;
    data_json?: Record<string, unknown>;
  }>;
}

type VisitorActivityResponseType = Record<string, never>;

export const logVisitorActivity = async (
  formData: VisitorActivityPayloadType,
): Promise<VisitorActivityResponseType> => {
  const {data} = await axiosClient.post<VisitorActivityResponseType>(
    'analytics/visitor-activity/',
    formData,
  );
  return data;
};
